import { useDispatch } from 'react-redux'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { resetOrder } from '@/ducks/onboarding/onboardingActions'

import './step-summary.scss'

const StepSummary = () => {
  const dispatch = useDispatch()
  const { whiteLabel } = useAppContext()

  return (
    <div id="step-summary" className="step">
      <h2 className={whiteLabel}>
        <Translation id="Din bestilling er registrert" />
      </h2>

      <p>
        <Translation id="Din ordre er registrert og sendt" />
      </p>

      <p>
        <Translation id="Du vil motta en SMS når bestillingen er godkjent" />
      </p>

      <p>
        <b>
          <Translation id="NB!" />
        </b>
        <br />
        <Translation id="Alle leveringer til Skøyen i Oslo vil leveres direkte" />
      </p>

      <p>
        <Translation id="Hvis du har spørsmål vedrørende din bestilling" />
      </p>

      <p>
        <b>Dustin AS</b>
        <br />
        E-post: storkunde@dustin.no
        <br />
        Tlf: 21 04 40 70
        <br />
        www.dustin.no
        <br />
      </p>

      <button onClick={() => dispatch(resetOrder())} className={`reset ${whiteLabel}`}>
        <Translation id="Ny ordre" />
      </button>
    </div>
  )
}

export default StepSummary
